import { render, staticRenderFns } from "./GPSRInfoDetailModal.vue?vue&type=template&id=6b9bc176&scoped=true&"
import script from "./GPSRInfoDetailModal.vue?vue&type=script&lang=ts&"
export * from "./GPSRInfoDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./GPSRInfoDetailModal.vue?vue&type=style&index=0&id=6b9bc176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bc176",
  null
  
)

export default component.exports